var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllClassesIco01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 221 219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-11,.cls-19,.cls-3{opacity:0.67;isolation:isolate;}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#radial-gradient);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#radial-gradient-2);}.cls-8{fill:url(#radial-gradient-3);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#radial-gradient-4);}.cls-14{fill:url(#linear-gradient-10);}.cls-15{fill:url(#radial-gradient-5);}.cls-16{fill:url(#radial-gradient-6);}.cls-17{fill:url(#linear-gradient-11);}.cls-18{fill:url(#linear-gradient-12);}.cls-19{fill:url(#linear-gradient-13);}.cls-20{fill:url(#linear-gradient-14);}.cls-21{fill:url(#radial-gradient-7);}.cls-22{fill:url(#linear-gradient-15);}.cls-23{fill:url(#radial-gradient-8);}.cls-24{fill:url(#radial-gradient-9);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 158.51,
    y1: 153.51,
    x2: 188.07,
    y2: 187.66,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 219.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#1c1e3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1e2141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#232a52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2a3d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e5ba7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 136.99,
    y1: 154.46,
    x2: 216.24,
    y2: 212.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 136.99,
    y1: 154.46,
    x2: 216.24,
    y2: 212.3,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 219.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f9fcfe",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#e8f3fb",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#cfe6f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 59.3,
    y1: 151.41,
    x2: 169.39,
    y2: 163.26,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 219.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c101f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202a4f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -57.2,
    cy: 506.81,
    r: 1,
    gradientTransform: "matrix(12.92, 0, 0, -12.92, 898.56, 6600.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5d5f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c101f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 13.13,
    y1: 205.41,
    x2: 188.96,
    y2: 72.77,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 219.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c101f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a56a3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -59.37,
    cy: 517.72,
    r: 1,
    gradientTransform: "matrix(23.62, 0, 0, -23.62, 1502.01, 12289.95)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -58.76,
    cy: 514.62,
    r: 1,
    gradientTransform: "matrix(19.11, 0, 0, -19.11, 1253.7, 9857.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d41216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d11217"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c71418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b8161a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#a3171b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8a171b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#6d1518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 123.62,
    y1: 48.4,
    x2: 136.87,
    y2: 5.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 135.84,
    y1: 66.13,
    x2: 142.8,
    y2: -31.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 135.84,
    y1: 66.13,
    x2: 142.8,
    y2: -31.74,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 174.5,
    y1: 133.57,
    x2: 126.11,
    y2: 33.98,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -44.14,
    cy: 547.74,
    r: 1,
    gradientTransform: "matrix(-6.86, 10.95, 10.95, 6.86, -6165.77, -3093.33)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 244.75,
    y1: 144.03,
    x2: 39.01,
    y2: 65.42,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: -59.37,
    cy: 517.72,
    r: 1,
    gradientTransform: "matrix(23.61, 0, 0, -23.61, 1560.32, 12347.63)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -49.93,
    cy: 542.28,
    r: 1,
    gradientTransform: "matrix(-10.14, 16.2, 16.2, 10.14, -9114.19, -4520.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5b408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#f3b109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#eea80d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#e59812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#d98315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#cb6817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bb4717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b84217"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 49.14,
    y1: 129.3,
    x2: 4.9,
    y2: 138.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 58.83,
    y1: 110.07,
    x2: -30.39,
    y2: 150.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 58.83,
    y1: 110.07,
    x2: -30.39,
    y2: 150.9,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 99.48,
    y1: 43.82,
    x2: 35.29,
    y2: 134.04,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: -85.35,
    cy: 538.48,
    r: 1,
    gradientTransform: "matrix(-6.32, -11.26, -11.26, 6.32, 5565.41, -4268.77)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 74.99,
    y1: -22.85,
    x2: 104.66,
    y2: 195.4,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: -59.37,
    cy: 517.69,
    r: 1,
    gradientTransform: "matrix(23.56, 0, 0, -23.56, 1472.94, 12341.84)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: -77.78,
    cy: 536.02,
    r: 1,
    gradientTransform: "matrix(-9.35, -16.67, -16.67, 9.35, 8232.1, -6171.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5fb130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5cae30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#54a430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#479330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#377d2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#24642a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175226"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.23,37.53s-8.67-.77-15.43,18.61a123.35,123.35,0,0,1-10.29,22.11c-9.67,5.72-18.44,2-25.18-3.9a46.48,46.48,0,0,0,11.48-4.93c9.26-5.52,14.95-20.3,21.92-28.53s17.14-3.52,17.48-3.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188.21,37.52c-.34-.15-10.64-4.74-17.48,3.37s-12.66,23-21.92,28.53a46.48,46.48,0,0,1-11.48,4.93A61.36,61.36,0,0,1,126.1,60.66c10.58,7.08,16.8,1.29,25.17-11.92C161.85,32.06,172.8,23.65,188.21,37.52Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M188.21,37.52c-.34-.15-10.64-4.74-17.48,3.37s-12.66,23-21.92,28.53a46.48,46.48,0,0,1-11.48,4.93A61.36,61.36,0,0,1,126.1,60.66c10.58,7.08,16.8,1.29,25.17-11.92C161.85,32.06,172.8,23.65,188.21,37.52Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.51,78.25c-5.72,9.63-12.14,17.29-17.69,21.08-6.16,4.2-19.92,13.62-38-11.73C89,62.64,52.65,28.39,29.6,66.51v-.1c0-2.16.34-36.2,30.07-41.75,19.11-3.82,40.26,9.68,57.08,27.65a55,55,0,0,0,9.36,8.35,60.8,60.8,0,0,0,11.23,13.69C144.07,80.23,152.84,84,162.51,78.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M149,69.66l-.28-.47c5.82-3.49,10.23-10.67,14.48-17.62a91,91,0,0,1,7.36-10.86l.43.36a90.71,90.71,0,0,0-7.31,10.8C159.34,58.87,154.9,66.12,149,69.66Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M29.59,66.41S33,45.05,42.72,35.75c8.69-8.31,27.19-21.52,51,.38,22.84,21,37.2,53.13,58.61,47.78,0,0-14.53,17.33-28.66,1.15s-32-39.76-48-45.74S36.34,46.87,29.59,66.41Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M123.63,85.05c-1.87-2.08-3.71-4.16-5.55-6.26l-5.47-6.32C109,68.26,105.3,64.06,101.48,60a147.51,147.51,0,0,0-12-11.64L88,47c-.54-.45-1.1-.85-1.65-1.28l-1.66-1.27-1.73-1.17a40.78,40.78,0,0,0-7.32-4A49.92,49.92,0,0,1,89.8,48a136.45,136.45,0,0,1,12.09,11.59c3.79,4.09,7.45,8.3,11,12.58Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M130.76,41.22a19.11,19.11,0,1,0-19.11-19.11A19.11,19.11,0,0,0,130.76,41.22Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M132.29,212s5.25-6.93-7.58-22.94a122.54,122.54,0,0,1-13.27-20.47c.28-11.23,8.11-16.67,16.67-19.26a46.37,46.37,0,0,0-1.92,12.35c-.23,10.77,9.27,23.44,12.55,33.72,3.23,10.1-6.12,16.4-6.43,16.6Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M132.31,212c.31-.21,9.66-6.51,6.43-16.61-3.28-10.27-12.79-22.94-12.55-33.72a46.37,46.37,0,0,1,1.92-12.35,61.36,61.36,0,0,1,17.55-2.24c-11.62,5.2-10,13.54-3.26,27.66C150.93,192.55,152.25,206.3,132.31,212Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M132.31,212c.31-.21,9.66-6.51,6.43-16.61-3.28-10.27-12.79-22.94-12.55-33.72a46.37,46.37,0,0,1,1.92-12.35,61.36,61.36,0,0,1,17.55-2.24c-11.62,5.2-10,13.54-3.26,27.66C150.93,192.55,152.25,206.3,132.31,212Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M111.44,168.59c-5.13-10-8.21-19.46-8.48-26.17-.29-7.45-1-24.11,30.12-26,30.6-1.84,78.92-14.46,58.85-54.24l.09.06c1.84,1.14,30.5,19.49,19.42,47.64-6.9,18.22-29.57,29-53.73,33.69a56.75,56.75,0,0,0-12,3.51,61.78,61.78,0,0,0-17.56,2.24C119.55,151.92,111.71,157.36,111.44,168.59Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M138.48,195.48a89.86,89.86,0,0,0-5.27-11.93c-3.67-7.35-7.45-15-7.3-21.88l.55,0c-.15,6.78,3.61,14.32,7.24,21.62a91.21,91.21,0,0,1,5.31,12Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M192,62.24s16.3,14.21,19,27.4c2.43,11.77,3.8,34.47-27.38,43-30,8.18-64.77,3.33-71.6,24.31,0,0-7-21.5,14.25-24.9s50.67-6,64.27-16.43S205,78.32,192,62.24Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M126.31,132q4.13-.71,8.25-1.38l8.26-1.28c5.5-.87,11-1.73,16.48-2.81a147.28,147.28,0,0,0,16.21-4l2-.63c.66-.22,1.31-.47,2-.71l2-.73,1.91-.85a39.85,39.85,0,0,0,7.26-4.08A50.18,50.18,0,0,1,175.63,123a135.22,135.22,0,0,1-16.23,4.09c-5.49,1-11,1.91-16.52,2.69Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M175.86,190.59a19.11,19.11,0,1,0-19.11-19.11A19.11,19.11,0,0,0,175.86,190.59Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M9.45,78.79S13,86.72,33.22,83.13A122.92,122.92,0,0,1,57.54,81.3c9.73,5.62,10.75,15.11,8.92,23.86a46.92,46.92,0,0,0-9.91-7.61c-9.35-5.37-25-3.1-35.61-5.15C10.52,90.4,9.48,79.18,9.45,78.8Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M9.44,78.8c0,.37,1.08,11.6,11.49,13.61,10.6,2,26.27-.22,35.61,5.15a47,47,0,0,1,9.92,7.61A61.46,61.46,0,0,1,60,121.65c1-12.69-7.08-15.28-22.71-16.12C17.57,104.48,4.88,99,9.44,78.8Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M9.44,78.8c0,.37,1.08,11.6,11.49,13.61,10.6,2,26.27-.22,35.61,5.15a47,47,0,0,1,9.92,7.61A61.46,61.46,0,0,1,60,121.65c1-12.69-7.08-15.28-22.71-16.12C17.57,104.48,4.88,99,9.44,78.8Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M57.54,81.31c11.21.28,21,2.13,27,5.11,6.67,3.32,21.63,10.71,8.36,38.89C79.89,153,67.79,201.5,112.32,203l-.1.05c-1.87,1.07-31.73,17.41-51.12-5.81-12.67-14.8-11.24-39.85-3.8-63.31A56.63,56.63,0,0,0,60,121.65a61.13,61.13,0,0,0,6.45-16.48C68.29,96.42,67.27,86.93,57.54,81.31Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M56.4,97.81c-5.88-3.39-14.3-3.7-22.45-4a91.05,91.05,0,0,1-13.07-1.1l.1-.55a89.86,89.86,0,0,0,13,1.09c8.21.32,16.7.65,22.7,4.09Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M112.22,203s-20.29,7.49-33.17,3.55C67.56,203.06,47,193.38,54.46,161.93c7.18-30.22,28.14-58.44,13-74.48,0,0,22.22,4.19,15,24.44s-19,47.34-16.4,64.27S91.88,206.69,112.22,203Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M82.49,111.88c-.9,2.64-1.82,5.27-2.74,7.9l-2.84,7.86c-1.88,5.25-3.77,10.49-5.43,15.81a144.49,144.49,0,0,0-4.31,16.12l-.4,2c-.12.68-.21,1.37-.31,2.06l-.3,2.07L66,167.81a40.8,40.8,0,0,0,.09,8.34,50.15,50.15,0,0,1,.66-16.66,139.2,139.2,0,0,1,4.19-16.21c1.73-5.31,3.6-10.56,5.57-15.78Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M24.11,155.56A19.11,19.11,0,1,0,5,136.45,19.11,19.11,0,0,0,24.11,155.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllClassesIco01);
export default __webpack_public_path__ + "static/media/AllClassesIco-01.23038b79fd3a04724814d17ff6cb0772.svg";
export { ForwardRef as ReactComponent };